import AuthActionTypes from 'store/modules/auth/constants';
import { ApplicationActions } from 'store/types';

import ActionTypes from './constants';
import { EventReasonsState } from './types';

const initialState: EventReasonsState = {
  catalogByTriggerType: {},
  promptContext: null,
  pendingTaggings: {},
  pendingSnooze: null
};

function eventReasonsReducer(
  state: EventReasonsState = initialState,
  action: ApplicationActions
): EventReasonsState {
  switch (action.type) {
    case ActionTypes.SET_EVENT_REASON_CATALOG:
      return {
        ...state,
        catalogByTriggerType: action.payload.catalogByTriggerType
      };
    case ActionTypes.OPEN_EVENT_REASON_PROMPT:
      return {
        ...state,
        promptContext: action.payload.promptContext
      };
    case ActionTypes.CLOSE_EVENT_REASON_PROMPT:
      return {
        ...state,
        promptContext: null
      };
    case ActionTypes.SET_PENDING_EVENT_REASON_TAGGING: {
      const { pendingTagging } = action.payload;
      return {
        ...state,
        pendingTaggings: {
          ...state.pendingTaggings,
          [pendingTagging.id]: pendingTagging
        }
      };
    }
    case ActionTypes.REMOVE_PENDING_EVENT_REASON_TAGGING: {
      const pendingTaggings = { ...state.pendingTaggings };
      delete pendingTaggings[action.payload.id];
      return {
        ...state,
        pendingTaggings
      };
    }
    case ActionTypes.SET_PENDING_EVENT_REASON_PROMPT_SNOOZE:
      return {
        ...state,
        pendingSnooze: action.payload.preference
      };
    case ActionTypes.REMOVE_PENDING_EVENT_REASON_PROMPT_SNOOZE:
      return {
        ...state,
        pendingSnooze: null
      };
    case AuthActionTypes.LOGOUT:
      return initialState;
    default:
      return state;
  }
}

export default eventReasonsReducer;
